import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BaseComponent } from '../base/base.component';
import { PageHeaderComponent } from '../core/labels/page-header.component';
import { TabPanelComponent } from '../core/panels/tab-panel/tab-panel.component';
import { TabComponent } from '../core/panels/tab-panel/tab.component';
import { DiaryViewComponent } from './client-diaries/diary-view.component';
import { TaskViewComponent } from './personal-tasks/task-view.component';
import { HomeCardComponent } from '../home/home-card.component';

@Component({
  selector: 'app-todo-view',
  imports: [
    TabPanelComponent,
    TabComponent,
    DiaryViewComponent,
    TaskViewComponent,
    PageHeaderComponent,
    CommonModule,
    RouterModule,
    HomeCardComponent,
  ],
  template: `
    @if (subheader) {
      <app-page-header label="My to-do" headerSize="h1" />
    } @else {
      <h1 class="tw-sr-only">My to-do</h1>
    }
    <div class="tw-grow tw-w-full tw-justify-center">
      <app-home-card type="Large" [overflow]="subheader ? 'visible' : 'hidden'">
        <div class="tw-pb-8 tw-w-full tw-min-w-0">
          <app-tab-panel
            [value]="tabValue"
            activeTabQueryParam="tab"
            (valueChange)="onTabChange($event)"
          >
            <app-tab
              label="Shared diaries"
              [visible]="sharedDiariesAuthorize && visibleSource"
            >
              <ng-template #content>
                <div class="tw-pb-4 tw-pt-6">
                  <app-diary-view />
                </div>
              </ng-template>
            </app-tab>
            <app-tab label="Personal tasks">
              <ng-template #content>
                <div class="tw-pb-4 tw-pt-6">
                  <app-task-view />
                </div>
              </ng-template>
            </app-tab>
          </app-tab-panel>
        </div>
      </app-home-card>
    </div>
  `,
  styles: ``,
})
export class TodoViewComponent extends BaseComponent implements OnInit {
  subheader = false;
  sharedDiariesAuthorize = false;
  tabValue: string = null;
  claim: any;
  visibleSource: any;
  setup() {
    this.sharedDiariesAuthorize =
      !this.session.isSpecificClaimUser &&
      this.session.authorize('ClientDiaryModule');
    this.visibleSource = true;
    if (!this.tabValue) {
      this.tabValue =
        this.sharedDiariesAuthorize && this.visibleSource
          ? 'Shared diaries'
          : 'Personal tasks';
    }
  }
  private applyTabFromRoute(): void {
    const tabFromQuery = this.activatedRoute.snapshot.queryParamMap.get('tab');
    this.tabValue = tabFromQuery ?? this.storage.get('tab-todo-view');
    if (this.tabValue) {
      this.storage.set('tab-todo-view', this.tabValue);
    }
  }

  onTabChange(value: string): void {
    this.tabValue = value;
    this.storage.set('tab-todo-view', value);
  }

  private syncDefaultTabToQueryString(): void {
    if (this.activatedRoute.snapshot.queryParamMap.has('tab') || !this.tabValue)
      return;
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: this.tabValue },
      queryParamsHandling: 'merge',
      replaceUrl: true,
    });
  }

  ngOnInit(): void {
    this.subheader = document.location.pathname !== '/todo';
    this.claim = this.view.currentClaim();

    this.applyTabFromRoute();

    this.dispose.subs = this.activatedRoute.queryParamMap.subscribe(() => {
      this.applyTabFromRoute();
      this.syncDefaultTabToQueryString();
    });

    if (this.subheader) {
      const showPersonalTasks = this.storage.get('todo-show-personal-tasks');
      if (showPersonalTasks === 'claim-specific-task-creation') {
        this.sharedDiariesAuthorize =
          !this.session.isSpecificClaimUser &&
          this.session.authorize('ClientDiaryModule');
        this.visibleSource = this.claim.recordSource !== 'R';
        if (!this.tabValue) {
          this.tabValue = 'Personal tasks';
        }
        this.storage.remove('todo-show-personal-tasks');
      } else {
        this.sharedDiariesAuthorize =
          !this.session.isSpecificClaimUser &&
          this.session.authorize('ClientDiaryModule');
        this.visibleSource = this.claim.recordSource !== 'R';
        if (!this.tabValue) {
          this.tabValue =
            this.sharedDiariesAuthorize && this.visibleSource
              ? 'Shared diaries'
              : 'Personal tasks';
        }
      }
    } else {
      this.setup();
      this.dispose.subs = this.session.updateUser.subscribe(
        (result: boolean) => {
          if (result) {
            this.setup();
          }
        },
      );
    }
    this.syncDefaultTabToQueryString();
    this.view.hideLoading();
  }
}
